import { Fonts } from '../../fonts';

function getStyles(typescale, viewport, typeSize) {
  return BodyConfig[typescale][viewport][typeSize];
}

var BodyConfig = {
  VDS: {
    mobile: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        letterSpacing: 0.5,
        fontFamily: Fonts.VerizonNHGeDS
      },
      medium: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: Fonts.VerizonNHGeTX
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: Fonts.VerizonNHGeTX
      }
    },
    desktop: {
      large: {
        fontSize: 16,
        lineHeight: 20,
        letterSpacing: 0.5,
        fontFamily: Fonts.VerizonNHGeDS
      },
      medium: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: Fonts.VerizonNHGeTX
      },
      small: {
        fontSize: 12,
        lineHeight: 16,
        fontFamily: Fonts.VerizonNHGeTX
      }
    }
  },
  getStyles: getStyles
};
export default BodyConfig;